/** Quarter-minute options for incident time (24-hour UI). */
export const INCIDENT_QUARTER_MINUTES = ['00', '15', '30', '45'] as const

export const INCIDENT_HOURS_24 = Array.from({ length: 24 }, (_, i) =>
  String(i).padStart(2, '0')
)

/** Windscreen / other incident UI uses `HH:--` / `--:MM` while incomplete. */
export function splitHm24(s: string): { hour: string; minute: string } {
  const t = s.trim()
  if (!t) return { hour: '', minute: '' }
  const partialH = /^(\d{1,2}):--$/.exec(t)
  if (partialH) {
    const h = Number(partialH[1])
    if (h >= 0 && h <= 23) return { hour: String(h), minute: '' }
    return { hour: '', minute: '' }
  }
  const partialM = /^--:(\d{2})$/.exec(t)
  if (partialM) return { hour: '', minute: partialM[1] }
  const full = /^(\d{1,2}):(\d{2})$/.exec(t)
  if (!full) return { hour: '', minute: '' }
  const h = Number(full[1])
  const min = full[2]
  if (h < 0 || h > 23 || Number(min) > 59) return { hour: '', minute: '' }
  return { hour: String(h), minute: min }
}

export function combineHm24(hour: string, minute: string): string {
  const hRaw = hour.trim()
  const m = minute.trim()
  if (!hRaw && !m) return ''
  if (hRaw && m) {
    const hn = Number(hRaw)
    if (hn >= 0 && hn <= 23) return `${String(hn).padStart(2, '0')}:${m}`
    return ''
  }
  if (hRaw) {
    const hn = Number(hRaw)
    if (hn >= 0 && hn <= 23) return `${String(hn).padStart(2, '0')}:--`
    return ''
  }
  return `--:${m}`
}

export function isQuarterMinuteToken(mm: string): mm is (typeof INCIDENT_QUARTER_MINUTES)[number] {
  return (INCIDENT_QUARTER_MINUTES as readonly string[]).includes(mm)
}

/** Human-readable label for the mobile time trigger button. */
export function formatIncidentTimeTriggerLabel(value: string): string {
  const { hour, minute } = splitHm24(value)
  const h = hour !== '' ? String(Number(hour)).padStart(2, '0') : ''
  const m = minute
  if (h && m) return `${h} : ${m}`
  if (h) return `${h} : —`
  if (m) return `— : ${m}`
  return ''
}
